export enum FeatureFlagConstant {
  BookingPaymentStep = 'Madar_2_FE_Enable_Payment_Page_onlineBooking',
  HeatMap = 'fe-enable-cement-org-map',
  FleetInvoices = 'enable-fleet-invoice',
  CustomerWebChat = 'enable-customer-web-chat',
}
